<template>
      <div class="invite-repairer-form text-center">
        <div class="intro-text">
          <div class="form">
            <br />
            <br />
            <h1>Create your business profile contact details</h1>
            <br />
            <form method="POST" @submit.prevent="login">
              <div class="form-group">
                <label for="phonenumber" class="form-group-input-title">Primary Phone Number</label>
                <input
                    ref="phone"
                    @keydown.up="focusOnElement('postcode')"
                    @keydown.down="focusOnElement('fax')"
                    autocomplete="off"
                    type="text"
                    class="form-control input-field"
                    name="phonenumber"
                    placeholder="Primary Phone Number"
                    @keypress="onlyNumber"
                    v-model="phone"
                />
                <div class="w-100 text-right" v-show="false">
                  <span class="error-text">
                    <i class="bx bxs-error" style="color:#FF5E5E"></i>&nbsp;Any error text
                  </span>
                </div>
              </div>

              <div class="form-group">
                <label for="fax" class="form-group-input-title">Primary Fax Number</label>
                <input
                    ref="fax"
                    @keydown.up="focusOnElement('phone')"
                    @keydown.down="focusOnElement('email')"
                    autocomplete="off"
                    type="text"
                    class="form-control input-field"
                    name="fax"
                    placeholder="Primary Fax Number"
                    v-model="fax"
                />
                <div class="w-100 text-right" v-show="false">
                  <span class="error-text">
                    <i class="bx bxs-error" style="color:#FF5E5E"></i>&nbsp;Any error text
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label for="email" class="form-group-input-title">Primary Email Address</label>
                <input
                    ref="email"
                    @keydown.up="focusOnElement('fax')"
                    @keydown.down="focusOnElement('address')"
                    autocomplete="off"
                    type="email"
                    class="form-control input-field"
                    name="email"
                    placeholder="Primary Email Address"
                    @blur="checkEmail"
                    @focus="isCheckEmail = true;"
                    v-model="email"
                />
                <div class="w-100 text-right" v-show="!isCheckEmail && email !== ''">
                  <span class="error-text">
                    <i class="bx bxs-error" style="color:#FF5E5E"></i>&nbsp;This email address is incorrect
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label for="address" class="form-group-input-title">Primary Business Address</label>
                <input
                    ref="address"
                    @keydown.up="focusOnElement('email')"
                    @keydown.down="focusOnElement('suburb')"
                    autocomplete="off"
                    type="text"
                    class="form-control input-field"
                    name="address"
                    placeholder="Street Address"
                    v-model="address"
                    :disabled="isSameAsBusinessAddress"
                />
                <div class="w-100 text-right" v-show="false">
                  <span class="error-text">
                    <i class="bx bxs-error" style="color:#FF5E5E"></i>&nbsp;Any error text
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label for="Suburb" class="form-group-input-title">Suburb</label>
                <input
                    ref="suburb"
                    @keydown.up="focusOnElement('address')"
                    @keydown.down="focusOnElement('state')"
                    autocomplete="off"
                    type="text"
                    class="form-control input-field"
                    name="Suburb"
                    placeholder="Suburb"
                    v-model="suburb"
                    :disabled="isSameAsBusinessAddress"
                />
                <div class="w-100 text-right" v-show="false">
                  <span class="error-text">
                    <i class="bx bxs-error" style="color:#FF5E5E"></i>&nbsp;Any error text
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label for="State" class="form-group-input-title">State</label>
                <div class="multiselect-style">
                  <multiselect
                      ref="state"
                      :options="getOptionsState"
                      :showLabels="false"
                      :max-height="203"
                      :close-on-select="true"
                      placeholder="Choose your state"
                      v-model="state"
                      :disabled="isSameAsBusinessAddress"
                  />
                </div>
                <div class="w-100 text-right" v-show="false">
                  <span class="error-text">
                    <i class="bx bxs-error" style="color:#FF5E5E"></i>&nbsp;Any error text
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label for="postcode" class="form-group-input-title">Postcode</label>
                <input
                    ref="postcode"
                    @keydown.up="focusOnElement('state')"
                    @keydown.down="focusOnElement('phone')"
                    autocomplete="off"
                    type="text"
                    class="form-control input-field post-code"
                    name="businessnumber"
                    placeholder="Postcode"
                    v-model="postcode"
                    @keydown.tab.prevent="$refs.nextButton.focus()"
                    :disabled="isSameAsBusinessAddress"
                />
                <div class="w-100 text-right" v-show="false">
                                    <span class="error-text">
                                        <i class="bx bxs-error" style="color:#FF5E5E"></i>&nbsp;Any error text
                                    </span>
                </div>
              </div>
              <div class="w-100 text-right row justify-content-end">
                <label class="form-check-inline checkbox remember-checkbox">
                  <input class="form-check-input"
                         @change="changedCheckBox"
                    name="remember"
                    type="checkbox"
                    aria-label="Same as registered business address"
                    v-model="isSameAsBusinessAddress"
                  />
                  <span class="icon"><i class='bx bx-check'></i></span><span class="checkbox-text">Same as registered business address</span>
                </label>
              </div>
              <div class="form-group">
                <div class="btn-group">
                  <button
                      ref="nextButton"
                    type="button"
                    class="btn input-btn"
                    :disabled="!nextAllowed"
                    @click="register"
                  >Next</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "InviteRepairerCreateBusinessProfile",
  components: {
    multiselect: Multiselect
  },
  data: function (){
    return {
      phone: '',
      fax: '',
      email: '',
      state: '',
      suburb: '',
      postcode: '',
      address: '',
      isSameAsBusinessAddress: false,
      isCheckEmail: true,
    };
  },
  props: {
    registrationData: {
      type: Object,
      default: {}
    }
  },
  mounted() {
    this.phone = this.registrationData.businessForSuppliers.phone;
    this.fax = this.registrationData.businessForSuppliers.fax;
    this.email = this.registrationData.businessForSuppliers.email;
    this.address = this.registrationData.businessForSuppliers.address;
    this.suburb = this.registrationData.businessForSuppliers.suburb;
    this.state = this.registrationData.businessForSuppliers.state;
    this.postcode = this.registrationData.businessForSuppliers.postcode;
    this.isSameAsBusinessAddress = this.registrationData.businessForSuppliers.isSameAsBusinessAddress;
  },
  methods: {
    focusOnElement(name) {
      if (name === 'state') {
        this.$refs[name].$el.focus();
      } else {
        this.$refs[name].focus();
      }
    },
    onlyNumber (event) {
      let keyCode = (event.keyCode ? event.keyCode : event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 32 && keyCode !== 45 && keyCode !== 43 && keyCode !== 40 && keyCode !== 41) {
        event.preventDefault();
      }
    },
    checkEmail() {
          let tlds = ".aaa .aarp .abarth .abb .abbott .abbvie .abc .able .abogado .abudhabi .ac .academy .accenture .accountant .accountants .aco .actor .ad .adac .ads .adult .ae .aeg .aero .aetna .af .afl .africa .ag .agakhan .agency .ai .aig .airbus .airforce .airtel .akdn .al .alfaromeo .alibaba .alipay .allfinanz .allstate .ally .alsace .alstom .am .amazon .americanexpress .americanfamily .amex .amfam .amica .amsterdam .analytics .android .anquan .anz .ao .aol .apartments .app .apple .aq .aquarelle .ar .arab .aramco .archi .army .arpa .art .arte .as .asda .asia .associates .at .athleta .attorney .au .auction .audi .audible .audio .auspost .author .auto .autos .avianca .aw .aws .ax .axa .az .azure .ba .baby .baidu .banamex .bananarepublic .band .bank .bar .barcelona .barclaycard .barclays .barefoot .bargains .baseball .basketball .bauhaus .bayern .bb .bbc .bbt .bbva .bcg .bcn .bd .be .beats .beauty .beer .bentley .berlin .best .bestbuy .bet .bf .bg .bh .bharti .bi .bible .bid .bike .bing .bingo .bio .biz .bj .black .blackfriday .blockbuster .blog .bloomberg .blue .bm .bms .bmw .bn .bnpparibas .bo .boats .boehringer .bofa .bom .bond .boo .book .booking .bosch .bostik .boston .bot .boutique .box .br .bradesco .bridgestone .broadway .broker .brother .brussels .bs .bt .build .builders .business .buy .buzz .bv .bw .by .bz .bzh .ca .cab .cafe .cal .call .calvinklein .cam .camera .camp .canon .capetown .capital .capitalone .car .caravan .cards .care .career .careers .cars .casa .case .cash .casino .cat .catering .catholic .cba .cbn .cbre .cbs .cc .cd .center .ceo .cern .cf .cfa .cfd .cg .ch .chanel .channel .charity .chase .chat .cheap .chintai .christmas .chrome .church .ci .cipriani .circle .cisco .citadel .citi .citic .city .cityeats .ck .cl .claims .cleaning .click .clinic .clinique .clothing .cloud .club .clubmed .cm .cn .co .coach .codes .coffee .college .cologne .com .comcast .commbank .community .company .compare .computer .comsec .condos .construction .consulting .contact .contractors .cooking .cookingchannel .cool .coop .corsica .country .coupon .coupons .courses .cpa .cr .credit .creditcard .creditunion .cricket .crown .crs .cruise .cruises .cu .cuisinella .cv .cw .cx .cy .cymru .cyou .cz .dabur .dad .dance .data .date .dating .datsun .day .dclk .dds .de .deal .dealer .deals .degree .delivery .dell .deloitte .delta .democrat .dental .dentist .desi .design .dev .dhl .diamonds .diet .digital .direct .directory .discount .discover .dish .diy .dj .dk .dm .dnp .do .docs .doctor .dog .domains .dot .download .drive .dtv .dubai .dunlop .dupont .durban .dvag .dvr .dz .earth .eat .ec .eco .edeka .edu .education .ee .eg .email .emerck .energy .engineer .engineering .enterprises .epson .equipment .er .ericsson .erni .es .esq .estate .et .etisalat .eu .eurovision .eus .events .exchange .expert .exposed .express .extraspace .fage .fail .fairwinds .faith .family .fan .fans .farm .farmers .fashion .fast .fedex .feedback .ferrari .ferrero .fi .fiat .fidelity .fido .film .final .finance .financial .fire .firestone .firmdale .fish .fishing .fit .fitness .fj .fk .flickr .flights .flir .florist .flowers .fly .fm .fo .foo .food .foodnetwork .football .ford .forex .forsale .forum .foundation .fox .fr .free .fresenius .frl .frogans .frontdoor .frontier .ftr .fujitsu .fun .fund .furniture .futbol .fyi .ga .gal .gallery .gallo .gallup .game .games .gap .garden .gay .gb .gbiz .gd .gdn .ge .gea .gent .genting .george .gf .gg .ggee .gh .gi .gift .gifts .gives .giving .gl .glass .gle .global .globo .gm .gmail .gmbh .gmo .gmx .gn .godaddy .gold .goldpoint .golf .goo .goodyear .goog .google .gop .got .gov .gp .gq .gr .grainger .graphics .gratis .green .gripe .grocery .group .gs .gt .gu .guardian .gucci .guge .guide .guitars .guru .gw .gy .hair .hamburg .hangout .haus .hbo .hdfc .hdfcbank .health .healthcare .help .helsinki .here .hermes .hgtv .hiphop .hisamitsu .hitachi .hiv .hk .hkt .hm .hn .hockey .holdings .holiday .homedepot .homegoods .homes .homesense .honda .horse .hospital .host .hosting .hot .hoteles .hotels .hotmail .house .how .hr .hsbc .ht .hu .hughes .hyatt .hyundai .ibm .icbc .ice .icu .id .ie .ieee .ifm .ikano .il .im .imamat .imdb .immo .immobilien .in .inc .industries .infiniti .info .ing .ink .institute .insurance .insure .int .international .intuit .investments .io .ipiranga .iq .ir .irish .is .ismaili .ist .istanbul .it .itau .itv .jaguar .java .jcb .je .jeep .jetzt .jewelry .jio .jll .jm .jmp .jnj .jo .jobs .joburg .jot .joy .jp .jpmorgan .jprs .juegos .juniper .kaufen .kddi .ke .kerryhotels .kerrylogistics .kerryproperties .kfh .kg .kh .ki .kia .kids .kim .kinder .kindle .kitchen .kiwi .km .kn .koeln .komatsu .kosher .kp .kpmg .kpn .kr .krd .kred .kuokgroup .kw .ky .kyoto .kz .la .lacaixa .lamborghini .lamer .lancaster .lancia .land .landrover .lanxess .lasalle .lat .latino .latrobe .law .lawyer .lb .lc .lds .lease .leclerc .lefrak .legal .lego .lexus .lgbt .li .lidl .life .lifeinsurance .lifestyle .lighting .like .lilly .limited .limo .lincoln .linde .link .lipsy .live .living .lk .llc .llp .loan .loans .locker .locus .loft .lol .london .lotte .lotto .love .lpl .lplfinancial .lr .ls .lt .ltd .ltda .lu .lundbeck .luxe .luxury .lv .ly .ma .macys .madrid .maif .maison .makeup .man .management .mango .map .market .marketing .markets .marriott .marshalls .maserati .mattel .mba .mc .mckinsey .md .me .med .media .meet .melbourne .meme .memorial .men .menu .merckmsd .mg .mh .miami .microsoft .mil .mini .mint .mit .mitsubishi .mk .ml .mlb .mls .mm .mma .mn .mo .mobi .mobile .moda .moe .moi .mom .monash .money .monster .mormon .mortgage .moscow .moto .motorcycles .mov .movie .mp .mq .mr .ms .msd .mt .mtn .mtr .mu .museum .music .mutual .mv .mw .mx .my .mz .na .nab .nagoya .name .natura .navy .nba .nc .ne .nec .net .netbank .netflix .network .neustar .new .news .next .nextdirect .nexus .nf .nfl .ng .ngo .nhk .ni .nico .nike .nikon .ninja .nissan .nissay .nl .no .nokia .northwesternmutual .norton .now .nowruz .nowtv .np .nr .nra .nrw .ntt .nu .nyc .nz .obi .observer .office .okinawa .olayan .olayangroup .oldnavy .ollo .om .omega .one .ong .onl .online .ooo .open .oracle .orange .org .organic .origins .osaka .otsuka .ott .ovh .pa .page .panasonic .paris .pars .partners .parts .party .passagens .pay .pccw .pe .pet .pf .pfizer .pg .ph .pharmacy .phd .philips .phone .photo .photography .photos .physio .pics .pictet .pictures .pid .pin .ping .pink .pioneer .pizza .pk .pl .place .play .playstation .plumbing .plus .pm .pn .pnc .pohl .poker .politie .porn .post .pr .pramerica .praxi .press .prime .pro .prod .productions .prof .progressive .promo .properties .property .protection .pru .prudential .ps .pt .pub .pw .pwc .py .qa .qpon .quebec .quest .racing .radio .re .read .realestate .realtor .realty .recipes .red .redstone .redumbrella .rehab .reise .reisen .reit .reliance .ren .rent .rentals .repair .report .republican .rest .restaurant .review .reviews .rexroth .rich .richardli .ricoh .ril .rio .rip .ro .rocher .rocks .rodeo .rogers .room .rs .rsvp .ru .rugby .ruhr .run .rw .rwe .ryukyu .sa .saarland .safe .safety .sakura .sale .salon .samsclub .samsung .sandvik .sandvikcoromant .sanofi .sap .sarl .sas .save .saxo .sb .sbi .sbs .sc .sca .scb .schaeffler .schmidt .scholarships .school .schule .schwarz .science .scot .sd .se .search .seat .secure .security .seek .select .sener .services .ses .seven .sew .sex .sexy .sfr .sg .sh .shangrila .sharp .shaw .shell .shia .shiksha .shoes .shop .shopping .shouji .show .showtime .si .silk .sina .singles .site .sj .sk .ski .skin .sky .skype .sl .sling .sm .smart .smile .sn .sncf .so .soccer .social .softbank .software .sohu .solar .solutions .song .sony .soy .spa .space .sport .spot .sr .srl .ss .st .stada .staples .star .statebank .statefarm .stc .stcgroup .stockholm .storage .store .stream .studio .study .style .su .sucks .supplies .supply .support .surf .surgery .suzuki .sv .swatch .swiss .sx .sy .sydney .systems .sz .tab .taipei .talk .taobao .target .tatamotors .tatar .tattoo .tax .taxi .tc .tci .td .tdk .team .tech .technology .tel .temasek .tennis .teva .tf .tg .th .thd .theater .theatre .tiaa .tickets .tienda .tiffany .tips .tires .tirol .tj .tjmaxx .tjx .tk .tkmaxx .tl .tm .tmall .tn .to .today .tokyo .tools .top .toray .toshiba .total .tours .town .toyota .toys .tr .trade .trading .training .travel .travelchannel .travelers .travelersinsurance .trust .trv .tt .tube .tui .tunes .tushu .tv .tvs .tw .tz .ua .ubank .ubs .ug .uk .unicom .university .uno .uol .ups .us .uy .uz .va .vacations .vana .vanguard .vc .ve .vegas .ventures .verisign .versicherung .vet .vg .vi .viajes .video .vig .viking .villas .vin .vip .virgin .visa .vision .viva .vivo .vlaanderen .vn .vodka .volkswagen .volvo .vote .voting .voto .voyage .vu .vuelos .wales .walmart .walter .wang .wanggou .watch .watches .weather .weatherchannel .webcam .weber .website .wed .wedding .weibo .weir .wf .whoswho .wien .wiki .williamhill .win .windows .wine .winners .wme .wolterskluwer .woodside .work .works .world .wow .ws .wtc .wtf .xbox .xerox .xfinity .xihuan .xin .xn--11b4c3d .xn--1ck2e1b .xn--1qqw23a .xn--2scrj9c .xn--30rr7y .xn--3bst00m .xn--3ds443g .xn--3e0b707e .xn--3hcrj9c .xn--3pxu8k .xn--42c2d9a .xn--45br5cyl .xn--45brj9c .xn--45q11c .xn--4dbrk0ce .xn--4gbrim .xn--54b7fta0cc .xn--55qw42g .xn--55qx5d .xn--5su34j936bgsg .xn--5tzm5g .xn--6frz82g .xn--6qq986b3xl .xn--80adxhks .xn--80ao21a .xn--80aqecdr1a .xn--80asehdb .xn--80aswg .xn--8y0a063a .xn--90a3ac .xn--90ae .xn--90ais .xn--9dbq2a .xn--9et52u .xn--9krt00a .xn--b4w605ferd .xn--bck1b9a5dre4c .xn--c1avg .xn--c2br7g .xn--cck2b3b .xn--cckwcxetd .xn--cg4bki .xn--clchc0ea0b2g2a9gcd .xn--czr694b .xn--czrs0t .xn--czru2d .xn--d1acj3b .xn--d1alf .xn--e1a4c .xn--eckvdtc9d .xn--efvy88h .xn--fct429k .xn--fhbei .xn--fiq228c5hs .xn--fiq64b .xn--fiqs8s .xn--fiqz9s .xn--fjq720a .xn--flw351e .xn--fpcrj9c3d .xn--fzc2c9e2c .xn--fzys8d69uvgm .xn--g2xx48c .xn--gckr3f0f .xn--gecrj9c .xn--gk3at1e .xn--h2breg3eve .xn--h2brj9c .xn--h2brj9c8c .xn--hxt814e .xn--i1b6b1a6a2e .xn--imr513n .xn--io0a7i .xn--j1aef .xn--j1amh .xn--j6w193g .xn--jlq480n2rg .xn--jlq61u9w7b .xn--jvr189m .xn--kcrx77d1x4a .xn--kprw13d .xn--kpry57d .xn--kput3i .xn--l1acc .xn--lgbbat1ad8j .xn--mgb9awbf .xn--mgba3a3ejt .xn--mgba3a4f16a .xn--mgba7c0bbn0a .xn--mgbaakc7dvf .xn--mgbaam7a8h .xn--mgbab2bd .xn--mgbah1a3hjkrd .xn--mgbai9azgqp6j .xn--mgbayh7gpa .xn--mgbbh1a .xn--mgbbh1a71e .xn--mgbc0a9azcg .xn--mgbca7dzdo .xn--mgbcpq6gpa1a .xn--mgberp4a5d4ar .xn--mgbgu82a .xn--mgbi4ecexp .xn--mgbpl2fh .xn--mgbt3dhd .xn--mgbtx2b .xn--mgbx4cd0ab .xn--mix891f .xn--mk1bu44c .xn--mxtq1m .xn--ngbc5azd .xn--ngbe9e0a .xn--ngbrx .xn--node .xn--nqv7f .xn--nqv7fs00ema .xn--nyqy26a .xn--o3cw4h .xn--ogbpf8fl .xn--otu796d .xn--p1acf .xn--p1ai .xn--pgbs0dh .xn--pssy2u .xn--q7ce6a .xn--q9jyb4c .xn--qcka1pmc .xn--qxa6a .xn--qxam .xn--rhqv96g .xn--rovu88b .xn--rvc1e0am3e .xn--s9brj9c .xn--ses554g .xn--t60b56a .xn--tckwe .xn--tiq49xqyj .xn--unup4y .xn--vermgensberater-ctb .xn--vermgensberatung-pwb .xn--vhquv .xn--vuq861b .xn--w4r85el8fhu5dnra .xn--w4rs40l .xn--wgbh1c .xn--wgbl6a .xn--xhq521b .xn--xkc2al3hye2a .xn--xkc2dl3a5ee0h .xn--y9a3aq .xn--yfro4i67o .xn--ygbi2ammx .xn--zfr164b .xxx .xyz .yachts .yahoo .yamaxun .yandex .ye .yodobashi .yoga .yokohama .you .youtube .yt .yun .za .zappos .zara .zero .zip .zm .zone .zuerich .zw";

          let email = this.email;
          let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          let endofString = email.split('.');
          let ending = endofString.length - 1;
          let tld = endofString[ending];
          if (!re.test(this.email)) {
            this.isCheckEmail = false;
          } else if (tlds.search(tld) < 0) {
            this.isCheckEmail = false;
          } else {
            this.isCheckEmail = true;
          }
    },
    changedCheckBox(value) {
      if (value) {
        this.address = this.registrationData.business.address;
        this.suburb = this.registrationData.business.city;
        this.state = this.registrationData.business.state;
        this.postcode = this.registrationData.business.postcode;
      }
    },
    register: function(){
      let businessForSuppliers = {};

      businessForSuppliers.phone = this.phone;
      businessForSuppliers.fax = this.fax;
      businessForSuppliers.email = this.email;
      businessForSuppliers.address = this.address;
      businessForSuppliers.suburb = this.suburb;
      businessForSuppliers.state = this.state;
      businessForSuppliers.postcode = this.postcode;
      businessForSuppliers.isSameAsBusinessAddress = this.isSameAsBusinessAddress;

      if(this.isSameAsBusinessAddress){
        businessForSuppliers.address = this.registrationData.business.address;
        businessForSuppliers.suburb = this.registrationData.business.city;
        businessForSuppliers.state = this.registrationData.business.state;
        businessForSuppliers.postcode = this.registrationData.business.postcode;
      }

      this.$emit('setData', {type: 3, data: businessForSuppliers})
      this.$emit('nextPage', 4)
    },
  },
  computed: {
    getOptions() {
      return ["Australian Public Company", "Australian Private Company"];
    },
    getOptionsCity() {
      return ["LAKEMBA", "Sydney"];
    },
    getOptionsState() {
      return ["NSW", "VIC", "QLD", "SA", "WA", "NT", "TAS"];
    },
    nextAllowed(){
      return !!(
        this.phone
      );
    }
  }
};
</script>

<style lang="css" scoped>
  form {
    max-width: 522px;
    margin: 0 auto;
  }
  .form {
    max-width: 771px;
    width: 100%;
    margin: 0 auto;
  }
  .steps-line {
    max-width: 652px;
    width: 100%;
    margin: 0 auto;
  }
  .form h1 {
    text-align: center;
    font-size: 32px;
    letter-spacing: 0;
    line-height: 43px;
    color: #1C1F39
  }
  .invite-repairer-form {
    justify-content: flex-start;
    margin-top: 5px;
  }
  .form .input-btn {
    display: table;
    margin: 0 auto;
    margin-top: 40px;
  }
</style>

<style scoped>
  .auth-header {
    background-color: #1f233d;
    height: 100px;
  }

  .logo-text {
    color: white;
  }

  .container {
    height: 100%;
  }

  .logo {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .steps-line ul {
    display: flex;
    justify-content: space-around;
    list-style-type: none;
  }

  .numb {
    display: none;
  }

  .form hr {
    margin-top: 50px;
    height: 1px;
    background-color: #1f233d;
  }

  .active {
    color: #5E79FF;
    font-weight: bold;
  }

  .custom-multiselect {
    margin: 0 auto;
    width: 70%;
  }

  .form-group-input-title {
    width: 100%;
    text-align: left;
    padding-left: 15px;
    font-size: 16px;
  }

  .post-code {
    width: 100%;
  }

  .input-btn {
    font-weight: bold;
    border-radius: 3px;
    background: linear-gradient(135deg, rgb(114, 103, 231) 0%, rgb(98, 89, 239) 49.12%, rgb(78, 69, 238) 100%);
    color: white;
    width: 100%;
    font-size: 16px;
    border: none;
  }

  .remember-checkbox {
    margin-top: 7px;
    white-space: nowrap;
  }

  .remember-checkbox input {
    margin-right: 20px;
  }

  .btn-group {
    display: flex;
    justify-content: space-between;
  }

  .btn-group>.btn:first-child {
    margin-left: auto;
  }

  .checkbox-text {
    height: 25px;
    display: block;
    margin: 4px 0 0 35px;
  }

  .form-control {
    font-family: "Nunito Sans";
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;
    padding: 9px 13px;
    border: 1px solid rgba(27, 30, 56, 0.2) !important;
    border-radius: 4px !important;
    height: 43px !important;
    color: #1C1F39;
  }

  .form-control::placeholder {
    font-family: "Nunito Sans";
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;
  }

  /* Disable uppercase for mobile devices */
  body.is-mobile .form-control,
  body.is-mobile .input-field,
  body.is-mobile input[type="text"],
  body.is-mobile input[type="email"] {
    text-transform: none !important;
  }

  .btn.disabled, .btn:disabled {
    cursor: not-allowed;
    opacity: .65;
    background: #adaeb2;
    border-color: #adaeb2;
  }

  .V3 .btn-primary.disabled:hover, .V3 .btn-primary:disabled:hover {
    background: #98999c;
    border-color: #98999c;
  }
</style>
